import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/** Palette of 12 distinct, accessible background colours. */
const COLOUR_PALETTE = [
    { bg: 'bg-red-400', text: 'text-white' },
    { bg: 'bg-orange-400', text: 'text-white' },
    { bg: 'bg-amber-400', text: 'text-gray-900' },
    { bg: 'bg-yellow-400', text: 'text-gray-900' },
    { bg: 'bg-lime-500', text: 'text-white' },
    { bg: 'bg-green-500', text: 'text-white' },
    { bg: 'bg-teal-500', text: 'text-white' },
    { bg: 'bg-cyan-500', text: 'text-white' },
    { bg: 'bg-blue-500', text: 'text-white' },
    { bg: 'bg-indigo-500', text: 'text-white' },
    { bg: 'bg-violet-500', text: 'text-white' },
    { bg: 'bg-pink-500', text: 'text-white' },
];
/**
 * Derive a stable palette index from a player ID string.
 * Uses a simple djb2-style hash so the colour is consistent across renders.
 */
function deriveColourIndex(playerId) {
    let hash = 5381;
    for (let i = 0; i < playerId.length; i++) {
        hash = (hash * 33) ^ playerId.charCodeAt(i);
        hash = hash >>> 0; // keep it 32-bit unsigned
    }
    return hash % COLOUR_PALETTE.length;
}
/** Extract up to two initials from a display name. */
function getInitials(displayName) {
    const parts = displayName.trim().split(/\s+/);
    if (parts.length === 0 || !parts[0])
        return '?';
    if (parts.length === 1) {
        return (parts[0][0] ?? '?').toUpperCase();
    }
    return ((parts[0][0] ?? '') + (parts[parts.length - 1]?.[0] ?? '')).toUpperCase();
}
const sizeClasses = {
    sm: 'h-7 w-7 text-xs',
    md: 'h-9 w-9 text-sm',
    lg: 'h-12 w-12 text-base',
    xl: 'h-16 w-16 text-xl',
};
const badgeSizeClasses = {
    sm: 'h-2 w-2',
    md: 'h-2.5 w-2.5',
    lg: 'h-3 w-3',
    xl: 'h-3.5 w-3.5',
};
export function Avatar({ displayName, playerId, size = 'md', online, className = '', }) {
    const colourIndex = deriveColourIndex(playerId);
    const colour = COLOUR_PALETTE[colourIndex] ?? COLOUR_PALETTE[0];
    const initials = getInitials(displayName);
    return (_jsxs("div", { className: ['relative inline-flex shrink-0', className].join(' '), children: [_jsx("div", { role: "img", "aria-label": displayName, title: displayName, className: [
                    'flex items-center justify-center rounded-full font-semibold select-none',
                    sizeClasses[size],
                    colour.bg,
                    colour.text,
                ].join(' '), children: _jsx("span", { "aria-hidden": "true", children: initials }) }), online !== undefined && (_jsxs(_Fragment, { children: [_jsx("span", { "aria-hidden": "true", className: [
                            'absolute bottom-0 right-0 block rounded-full ring-2 ring-white dark:ring-gray-800',
                            badgeSizeClasses[size],
                            online ? 'bg-green-400' : 'bg-gray-300 dark:bg-gray-500',
                        ].join(' ') }), _jsx("span", { className: "sr-only", children: online ? 'Online' : 'Offline' })] }))] }));
}
//# sourceMappingURL=Avatar.js.map